import {
  passwordValidationRules,
  passwordValidations,
  required,
} from '@app/dashboard/utils/formValidations';

const BASE_INITIAL_STATE = {
  errorMsg: '',
  isValid: false,
  value: '',
};

export const PASSWORD_FIELDS = {
  CURRENT_PASSWORD: 'currentPassword',
  NEW_PASSWORD: 'newPassword',
  CONFIRM_NEW_PASSWORD: 'confirmNewPassword',
} as const;

export const CHANGE_PASSWORD_INITIAL_STATE = {
  [PASSWORD_FIELDS.CURRENT_PASSWORD]: {
    ...BASE_INITIAL_STATE,
    validations: [required, ...passwordValidations],
  },
  [PASSWORD_FIELDS.NEW_PASSWORD]: {
    ...BASE_INITIAL_STATE,
    validations: passwordValidationRules,
  },
  [PASSWORD_FIELDS.CONFIRM_NEW_PASSWORD]: {
    ...BASE_INITIAL_STATE,
    validations: [required],
  },
};
